import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/banner_work.jpeg'


const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["src"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = {
  key: 3,
  class: "achieve-jupas-wrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_accordion = _resolveComponent("ion-accordion")!
  const _component_ion_accordion_group = _resolveComponent("ion-accordion-group")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_home_action_item = _resolveComponent("home-action-item")!
  const _component_event_card = _resolveComponent("event-card")!
  const _component_ActionAccordionGroup = _resolveComponent("ActionAccordionGroup")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_home_action_header = _resolveComponent("home-action-header")!
  const _component_AchieveJUPASResultPageModal = _resolveComponent("AchieveJUPASResultPageModal")!

  return ($setup.loadingData)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_ion_spinner)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(_component_ion_toolbar, { class: "sticky-toolbar" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_segment, {
              class: "view-type-segment",
              mode: "ios",
              modelValue: $setup.selectedViews.type,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedViews.type) = $event)),
              scrollable: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_segment_button, {
                  value: "Sharing",
                  class: "short-segment-btn"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: $setup.qrCodeOutline }, null, 8, ["icon"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_segment_button, {
                  value: "resources",
                  class: "short-segment-btn"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, {
                      class: "no-text-transform",
                      style: {"font-size":"2em"}
                    }, {
                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                        _createTextVNode("😍")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_segment_button, { value: "AchieveJUPAS" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, {
                      class: "no-text-transform",
                      style: {"line-height":"1.5"}
                    }, {
                      default: _withCtx(() => _cache[11] || (_cache[11] = [
                        _createElementVNode("b", null, "AchieveJUPAS", -1),
                        _createElementVNode("br", null, null, -1),
                        _createTextVNode("2.0 (beta)")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_segment_button, { value: "school-arranged" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, {
                      class: "no-text-transform",
                      style: {"line-height":"1.5"}
                    }, {
                      default: _withCtx(() => _cache[12] || (_cache[12] = [
                        _createTextVNode("School"),
                        _createElementVNode("br", null, null, -1),
                        _createTextVNode("arranged")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_segment_button, {
                  value: "sndas",
                  disabled: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, { class: "no-text-transform" }, {
                      default: _withCtx(() => _cache[13] || (_cache[13] = [
                        _createTextVNode("SNDAS")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_segment_button, {
                  value: "overseas-study",
                  disabled: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, { class: "no-text-transform" }, {
                      default: _withCtx(() => _cache[14] || (_cache[14] = [
                        _createTextVNode("Overseas Study")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_segment_button, {
                  value: "e-app",
                  disabled: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, { class: "no-text-transform" }, {
                      default: _withCtx(() => _cache[15] || (_cache[15] = [
                        _createTextVNode("E-App")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        ($setup.selectedViews.type == 'Sharing')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_ion_card, {
                class: "class-bar",
                style: {"margin-top":"0","margin-bottom":"0"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_content, { style: {"padding":"0"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_accordion_group, { value: "Sharing" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_accordion, {
                            style: {"--min-height":"24px","padding-left":"12px"},
                            value: "Sharing"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_item, {
                                lines: "full",
                                slot: "header"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, { style: {"margin":"4px 8px 4px 12px"} }, {
                                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                                      _createElementVNode("p", { style: {"font-weight":"500"} }, [
                                        _createElementVNode("b", null, "Share this tool with my classmates")
                                      ], -1)
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_list, {
                                class: "ion-text-center",
                                slot: "content"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("p", null, [
                                    _createElementVNode("img", {
                                      style: {"width":"300px"},
                                      src: $setup.getQRCodeUrl(`https://ab.fdmt.hk/s/${$setup.user.schoolId}`)
                                    }, null, 8, _hoisted_4)
                                  ]),
                                  _createElementVNode("p", null, "ab.fdmt.hk/s/" + _toDisplayString($setup.user.schoolId), 1),
                                  _createVNode(_component_ion_button, {
                                    color: "success",
                                    size: "small",
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.copyText(`https://ab.fdmt.hk/s/${$setup.user.schoolId}`)))
                                  }, {
                                    default: _withCtx(() => _cache[17] || (_cache[17] = [
                                      _createTextVNode(" Copy ")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : ($setup.selectedViews.type === 'resources')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _cache[36] || (_cache[36] = _createElementVNode("img", {
                  src: _imports_0,
                  style: {"width":"100%","margin-bottom":"-3px"}
                }, null, -1)),
                _createVNode(_component_ion_toolbar, { style: {"--min-height":"27px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, {
                      lines: "full",
                      button: "",
                      detail: "",
                      color: "primary",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.openSLPModal(true)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { class: "ion-text-wrap ion-text-center" }, {
                          default: _withCtx(() => _cache[18] || (_cache[18] = [
                            _createElementVNode("p", { style: {"margin":"0","color":"#fff"} }, "AchieveSLP preview", -1),
                            _createElementVNode("small", null, "unlocked upon successful Work event enrollment", -1)
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_card, { style: {"margin-top":"0"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_content, { style: {"padding":"0"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ActionAccordionGroup, {
                          noPadding: true,
                          value: "eligible-work-applicant",
                          headerColor: 'light'
                        }, {
                          header: _withCtx(() => _cache[19] || (_cache[19] = [
                            _createElementVNode("p", { style: {"color":"#888888"} }, [
                              _createElementVNode("b", null, "1. Eligible Work applicant")
                            ], -1)
                          ])),
                          default: _withCtx(() => [
                            ($setup.user.isAdmin)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getServicesByIds(['s8cdc05c8']), (service) => {
                                    return (_openBlock(), _createBlock(_component_home_action_item, {
                                      key: service.id,
                                      onClick: ($event: any) => ($setup.openServiceModal(service.id, service.lastAppliedSession, true)),
                                      isLesson: true,
                                      title: $setup.getServiceName(service)
                                    }, null, 8, ["onClick", "title"]))
                                  }), 128))
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getWorkshopServicesByUserLevel('eligible-work-applicant'), (service) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: service.id
                                    }, [
                                      _createVNode(_component_home_action_item, {
                                        onClick: ($event: any) => ($setup.openServiceModal(service.id, service.lastAppliedSession, true)),
                                        isLesson: true,
                                        title: $setup.getServiceName(service)
                                      }, null, 8, ["onClick", "title"]),
                                      (service.lastAppliedSession)
                                        ? (_openBlock(), _createBlock(_component_event_card, {
                                            key: 0,
                                            ev: service.lastAppliedSession,
                                            user: $setup.user,
                                            hideEventDetails: true,
                                            hideApplyButton: true,
                                            style: {"margin":"0","padding-left":"32px","box-shadow":"none"}
                                          }, null, 8, ["ev", "user"]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128))
                                ]))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ActionAccordionGroup, {
                          noPadding: true,
                          value: "shortlisted-work-applicant",
                          headerColor: 'light'
                        }, {
                          header: _withCtx(() => _cache[20] || (_cache[20] = [
                            _createElementVNode("p", { style: {"color":"#888888"} }, [
                              _createElementVNode("b", null, "2. Shortlisted Work applicant")
                            ], -1)
                          ])),
                          default: _withCtx(() => [
                            ($setup.user.isAdmin)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getServicesByIds(['s1b2ed9be']), (service) => {
                                    return (_openBlock(), _createBlock(_component_home_action_item, {
                                      key: service.id,
                                      onClick: ($event: any) => ($setup.openServiceModal(service.id, service.lastAppliedSession, true)),
                                      isLesson: true,
                                      title: $setup.getServiceName(service)
                                    }, null, 8, ["onClick", "title"]))
                                  }), 128))
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getWorkshopServicesByUserLevel('shortlisted-work-applicant'), (service) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: service.id
                                    }, [
                                      _createVNode(_component_home_action_item, {
                                        onClick: ($event: any) => ($setup.openServiceModal(service.id, service.lastAppliedSession, true)),
                                        isLesson: true,
                                        title: $setup.getServiceName(service)
                                      }, null, 8, ["onClick", "title"])
                                    ]))
                                  }), 128))
                                ]))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ActionAccordionGroup, {
                          noPadding: true,
                          value: "outstanding-work-applicant",
                          headerColor: 'light'
                        }, {
                          header: _withCtx(() => _cache[21] || (_cache[21] = [
                            _createElementVNode("p", { style: {"color":"#888888"} }, [
                              _createElementVNode("b", null, "3. (Outstanding) Work participant")
                            ], -1)
                          ])),
                          default: _withCtx(() => [
                            ($setup.user.isAdmin)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getServicesByIds(['saff28abc']), (service) => {
                                    return (_openBlock(), _createBlock(_component_home_action_item, {
                                      key: service.id,
                                      onClick: ($event: any) => ($setup.openServiceModal(service.id, service.lastAppliedSession, true)),
                                      isLesson: true,
                                      title: $setup.getServiceName(service)
                                    }, null, 8, ["onClick", "title"]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.workVisitEvents, (ev) => {
                              return _withDirectives((_openBlock(), _createElementBlock("div", {
                                key: ev.id
                              }, [
                                _createVNode(_component_home_action_item, {
                                  onClick: ($event: any) => ($setup.openServiceModal(ev.serviceId, ev, true)),
                                  isLesson: true,
                                  title: `${ev.name} (${ev.date} ${ev.startTime})`
                                }, null, 8, ["onClick", "title"])
                              ])), [
                                [_vShow, (ev.userResponse && ev.userResponse.isOutstandingStudent)]
                              ])
                            }), 128))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ActionAccordionGroup, {
                          noPadding: true,
                          value: "work-ambassador",
                          headerColor: 'light'
                        }, {
                          header: _withCtx(() => _cache[22] || (_cache[22] = [
                            _createElementVNode("p", { style: {"color":"#888888"} }, [
                              _createElementVNode("b", null, "4. Work Ambassador")
                            ], -1)
                          ])),
                          default: _withCtx(() => [
                            ($setup.user.isAdmin)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getServicesByIds(['s7e83d1c3']), (service) => {
                                    return (_openBlock(), _createBlock(_component_home_action_item, {
                                      key: service.id,
                                      onClick: ($event: any) => ($setup.openServiceModal(service.id, service.lastAppliedSession, true)),
                                      isLesson: true,
                                      title: $setup.getServiceName(service)
                                    }, null, 8, ["onClick", "title"]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            ($setup.user.isAdmin || $setup.workVisitEvents.some(ev => ev.userResponse && ev.userResponse.isOutstandingStudent))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.workVisitEvents.filter(ev => ev.userResponse && ev.userResponse.isOutstandingStudent), (ev) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: ev.id
                                    }, [
                                      _createVNode(_component_home_action_item, {
                                        onClick: ($event: any) => ($setup.openServiceModal(ev.serviceId, null, true, { isOutstandingParticipantView: true })),
                                        isLesson: true,
                                        title: "Example Work video & previous shooting photos "
                                      }, null, 8, ["onClick"])
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ActionAccordionGroup, {
                          noPadding: true,
                          value: "bluebird-seed-eligible-applicant",
                          headerColor: 'light'
                        }, {
                          header: _withCtx(() => _cache[23] || (_cache[23] = [
                            _createElementVNode("p", { style: {"color":"#888888"} }, [
                              _createElementVNode("b", null, "5. Bluebird Seed Eligible applicant")
                            ], -1)
                          ])),
                          default: _withCtx(() => [
                            _createVNode(_component_home_action_item, {
                              isLesson: true,
                              title: "Bluebird Seed",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.openServiceModal('bluebird-seed')))
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ActionAccordionGroup, {
                          noPadding: true,
                          value: "bluebird-seed-member",
                          headerColor: 'light'
                        }, {
                          header: _withCtx(() => _cache[24] || (_cache[24] = [
                            _createElementVNode("p", { style: {"color":"#888888"} }, [
                              _createElementVNode("b", null, "6. Bluebird Seed Member")
                            ], -1)
                          ])),
                          default: _withCtx(() => [
                            ($setup.user.isAdmin && $setup.user.schoolId == 'htc')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                  _createVNode(_component_ion_item, { lines: "full" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, { style: {"padding-left":"32px"} }, {
                                        default: _withCtx(() => _cache[25] || (_cache[25] = [
                                          _createElementVNode("b", null, "Co-supervisors: Ms. Lilian Ho (HTC), Brandon Chan (FDMT)", -1)
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ActionAccordionGroup, {
                                    style: {"padding-left":"20px"},
                                    noPadding: true,
                                    headerColor: 'light',
                                    value: "tasks"
                                  }, {
                                    header: _withCtx(() => _cache[26] || (_cache[26] = [
                                      _createElementVNode("p", null, [
                                        _createElementVNode("b", null, "Project logs")
                                      ], -1)
                                    ])),
                                    default: _withCtx(() => [
                                      _createElementVNode("div", null, [
                                        _createVNode(_component_ion_item, {
                                          button: "",
                                          lines: "full"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_label, {
                                              class: "ion-text-wrap",
                                              style: {"padding-left":"32px"}
                                            }, {
                                              default: _withCtx(() => _cache[27] || (_cache[27] = [
                                                _createElementVNode("b", null, "AchieveJUPAS UI Updates", -1),
                                                _createElementVNode("p", null, "Show version history of program choices", -1),
                                                _createElementVNode("p", null, "Expected completion: 2025-04-30", -1)
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_ion_badge, {
                                              color: "medium",
                                              slot: "end"
                                            }, {
                                              default: _withCtx(() => _cache[28] || (_cache[28] = [
                                                _createTextVNode("Planned")
                                              ])),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ActionAccordionGroup, {
                          noPadding: true,
                          value: "bluebird-seed-scholarship-holder",
                          headerColor: 'light'
                        }, {
                          header: _withCtx(() => _cache[29] || (_cache[29] = [
                            _createElementVNode("p", { style: {"color":"#888888"} }, [
                              _createElementVNode("b", null, "7. Bluebird Seed Scholarship holder")
                            ], -1)
                          ])),
                          default: _withCtx(() => [
                            _cache[30] || (_cache[30] = _createElementVNode("div", null, null, -1))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ActionAccordionGroup, {
                          noPadding: true,
                          value: "bluebird-member",
                          headerColor: 'light'
                        }, {
                          header: _withCtx(() => _cache[31] || (_cache[31] = [
                            _createElementVNode("p", { style: {"color":"#888888"} }, [
                              _createElementVNode("b", null, "8. Bluebird Member")
                            ], -1)
                          ])),
                          default: _withCtx(() => [
                            _cache[32] || (_cache[32] = _createElementVNode("div", null, null, -1))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ActionAccordionGroup, {
                          noPadding: true,
                          value: "bluebird-scholarship-holder",
                          headerColor: 'light'
                        }, {
                          header: _withCtx(() => _cache[33] || (_cache[33] = [
                            _createElementVNode("p", { style: {"color":"#888888"} }, [
                              _createElementVNode("b", null, "9. Bluebird Scholarship holder")
                            ], -1)
                          ])),
                          default: _withCtx(() => [
                            _cache[34] || (_cache[34] = _createElementVNode("div", null, null, -1))
                          ]),
                          _: 1
                        }),
                        false
                          ? (_openBlock(), _createBlock(_component_ActionAccordionGroup, {
                              key: 0,
                              noPadding: true,
                              value: "Other",
                              headerColor: 'light'
                            }, {
                              header: _withCtx(() => _cache[35] || (_cache[35] = [
                                _createElementVNode("p", { style: {"color":"#888888"} }, [
                                  _createElementVNode("b", null, "Other")
                                ], -1)
                              ])),
                              default: _withCtx(() => [
                                _createVNode(_component_home_action_item, {
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.openServiceModal('lms-scholarship', $setup.getSessionById('e4c145b9'), true))),
                                  isLesson: true,
                                  title: "HK$300k scholarship",
                                  isDisabled: !$setup.user.isAdmin && Number($setup.user.yearDSE) >= $setup.getF5YearDSE()
                                }, null, 8, ["isDisabled"]),
                                ($setup.user.isAdmin || $setup.user.secondarySchoolStudent?.group == 'ucircle')
                                  ? (_openBlock(), _createBlock(_component_home_action_item, {
                                      key: 0,
                                      title: "University-connected student club: Bluebird Seed",
                                      isLesson: true,
                                      onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.openWorkEventsModal('c3faecaac')))
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_home_action_item, {
                                  noIndent: true,
                                  title: "AI images for professions",
                                  onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.openAIProfessionImageModal()))
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]))
            : ($setup.selectedViews.type == 'school-arranged')
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_home_action_header, { title: "University Visits" }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.workVisitEvents, (ev) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: ev.id
                      }, [
                        _withDirectives(_createVNode(_component_home_action_item, {
                          onClick: ($event: any) => ($setup.openServiceModal(ev.serviceId, ev, true)),
                          isLesson: true,
                          title: `${ev.name} (${ev.date} ${ev.startTime})`
                        }, null, 8, ["onClick", "title"]), [
                          [_vShow, $setup.user.isAdmin || ev.userResponse || ev.clientSchoolId == $setup.user.schoolId]
                        ]),
                        (ev.userResponse)
                          ? (_openBlock(), _createBlock(_component_event_card, {
                              key: 0,
                              ev: ev,
                              user: $setup.user,
                              hideEventDetails: true,
                              hideApplyButton: true,
                              style: {"margin":"0","padding-left":"32px","box-shadow":"none"}
                            }, null, 8, ["ev", "user"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  (($setup.user.teacher || $setup.isAB4User) && $setup.user.yearDSE <= $setup.getF4YearDSE())
                    ? (_openBlock(), _createBlock(_component_ion_card, {
                        key: 0,
                        style: {"margin-top":"0"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_home_action_header, { title: "AB4" }),
                          _createVNode(_component_ion_card_content, { style: {"padding":"0"} }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_accordion_group, { value: "L1" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_accordion, {
                                    style: {"--min-height":"24px"},
                                    value: "L1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_item, {
                                        class: "ion-no-padding",
                                        lines: "full",
                                        slot: "header"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_icon, {
                                            slot: "start",
                                            icon: null
                                          }),
                                          _createVNode(_component_ion_label, null, {
                                            default: _withCtx(() => _cache[37] || (_cache[37] = [
                                              _createElementVNode("span", null, [
                                                _createElementVNode("b", null, "Lesson 1")
                                              ], -1)
                                            ])),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_list, {
                                        class: "ion-no-padding",
                                        slot: "content"
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredAB4Sessions('abs-session1'), (ev) => {
                                            return _withDirectives((_openBlock(), _createBlock(_component_event_card, {
                                              key: ev.id,
                                              ev: ev,
                                              user: $setup.user,
                                              showStudentFormsOnly: true,
                                              useAccordionView: true
                                            }, null, 8, ["ev", "user"])), [
                                              [_vShow, ev.formattedDateTime && $setup.isShowEvent(ev)]
                                            ])
                                          }), 128))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_home_action_item, {
                                title: "Target 1 among 400+ professions",
                                isDone: $setup.isSelectedProfessions() && $setup.userChoices.step1ProfessionReason && $setup.userChoices.step1ProfessionAction,
                                onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.openProfessionSelectModal())),
                                isLoading: $setup.loadingPortalData
                              }, null, 8, ["isDone", "isLoading"]),
                              _createVNode(_component_ion_accordion_group, { value: "ab4-l2" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_accordion, {
                                    style: {"--min-height":"24px"},
                                    value: "ab4-l2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_item, {
                                        class: "ion-no-padding",
                                        lines: "full",
                                        slot: "header"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_icon, {
                                            slot: "start",
                                            icon: null
                                          }),
                                          _createVNode(_component_ion_label, null, {
                                            default: _withCtx(() => _cache[38] || (_cache[38] = [
                                              _createElementVNode("span", null, [
                                                _createElementVNode("b", null, "Lesson 2")
                                              ], -1)
                                            ])),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_list, {
                                        class: "ion-no-padding",
                                        slot: "content"
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredAB4Sessions('abs-session2'), (ev) => {
                                            return _withDirectives((_openBlock(), _createBlock(_component_event_card, {
                                              key: ev.id,
                                              ev: ev,
                                              user: $setup.user,
                                              showStudentFormsOnly: true,
                                              useAccordionView: true
                                            }, null, 8, ["ev", "user"])), [
                                              [_vShow, ev.formattedDateTime && $setup.isShowEvent(ev)]
                                            ])
                                          }), 128))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              ($setup.user.isAdmin || $setup.isUserAttendedLesson('abs-session2'))
                                ? (_openBlock(), _createBlock(_component_home_action_item, {
                                    key: 0,
                                    title: "Choose 1-4 among 140+ disciplines",
                                    isDone: $setup.isSelectedDisciplines(),
                                    onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.openDisciplineSelectModal()))
                                  }, null, 8, ["isDone"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (($setup.user.teacher || $setup.isAB4User) && $setup.user.yearDSE <= $setup.getF4YearDSE())
                    ? (_openBlock(), _createBlock(_component_ion_card, {
                        key: 1,
                        style: {"margin-top":"0"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_home_action_header, { title: "AB3" }),
                          _createVNode(_component_ion_card_content, { style: {"padding":"0"} }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_accordion_group, { value: "ab3-session1" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_accordion, {
                                    style: {"--min-height":"24px"},
                                    value: "L1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_item, {
                                        class: "ion-no-padding",
                                        lines: "full",
                                        slot: "header"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_icon, {
                                            slot: "start",
                                            icon: null
                                          }),
                                          _createVNode(_component_ion_label, null, {
                                            default: _withCtx(() => _cache[39] || (_cache[39] = [
                                              _createElementVNode("span", null, [
                                                _createElementVNode("b", null, "Parent talk")
                                              ], -1)
                                            ])),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_list, {
                                        class: "ion-no-padding",
                                        slot: "content"
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredAB4Sessions('ab3-session1'), (ev) => {
                                            return _withDirectives((_openBlock(), _createBlock(_component_event_card, {
                                              key: ev.id,
                                              ev: ev,
                                              user: $setup.user,
                                              showStudentFormsOnly: true,
                                              useAccordionView: true
                                            }, null, 8, ["ev", "user"])), [
                                              [_vShow, ev.formattedDateTime && $setup.isShowEvent(ev)]
                                            ])
                                          }), 128))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_home_action_item, {
                                title: "AchieveElective (beta)",
                                onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.openAB3Modal())),
                                isLoading: $setup.loadingPortalData
                              }, null, 8, ["isLoading"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createVNode(_component_AchieveJUPASResultPageModal, { hideTitle: true })
                ]))
      ]))
}